export const TASK_STATUSES = {
  READING_PENDING: 'READING_PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
};